import { createContext, useContext } from "react";

export const ProtoContext = createContext(null);
export const useProto = () => useContext(ProtoContext);
